import type { MouseEventHandler } from 'react';
import { Box } from '@mui/material';
import { ArrowLeftIcon, ArrowRightIcon } from '../icons';

type ArrowButtonProps = {
    direction: 'left' | 'right';
    size?: number;
    disabled?: boolean;
    testId?: string;
    onClick: MouseEventHandler;
    className?: string;
};

export default function ArrowButton(props: ArrowButtonProps) {
    const {
        direction,
        size = 16,
        disabled = false,
        testId,
        onClick,
        className,
    } = props;

    return (
        <Box
            component="button"
            className={className}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            data-testid={testId}
            sx={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                border: 0,
                background: 'transparent',
            }}
        >
            {direction === 'left' ? (
                <ArrowLeftIcon size={size} />
            ) : (
                <ArrowRightIcon size={size} />
            )}
        </Box>
    );
}
